import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { LoadingPage } from '@/_shared/components/LoadingPage';
import { Wizard, WizardProps } from '@/_shared/components/Wizard';
import { Routes } from '@/_shared/constants';
import { UserQuizStatusEnum } from '@/swagger/constants/quiz-enums';
import { getContentDetailsCall } from '@/training/hardSkills/state/api';
import { CallResponseGetQuizById, postQuizStartCall } from '../../state/api';
import { EmployeeCompleteQuiz } from '../EmployeeCompleteQuiz';
import { QuizCompletedThankYouPage } from '../TYP';

export const WizardQuiz = () => {
  const t = useTranslations('quiz.dynamicQuiz.quizResult.cta');
  const navigate = useNavigate();
  const {
    response: responseGetContentDetails,
    execute: executeGetContentDetails,
    loading: loadingGetContentDetails,
  } = getContentDetailsCall.hook();
  const { execute: executePostQuizStart, loading: loadingPostQuizStart } = postQuizStartCall.hook();
  const { quizId } = useParams();

  const wizardSteps: WizardProps['stepsConfig'] = [
    {
      label: '',
      steps: [
        {
          label: 'Employee Complete Quiz',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <EmployeeCompleteQuiz wizardNavigationButton={wizardNavigationButton} />
          ),
          showSkipButton: false,
          showNextButton: false,
          showPreviousButton: false,
        },
        {
          label: 'TYP',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <QuizCompletedThankYouPage wizardNavigationButton={wizardNavigationButton} />
          ),
          showSkipButton: false,
          showNextButton: false,
          showPreviousButton: false,
          skipButtonLabel: t('restart'),
          nextButtonLabel: t('next'),
        },
      ],
    },
  ];

  useEffect(() => {
    if (quizId && !responseGetContentDetails?.id) {
      executeGetContentDetails({
        contentId: quizId,
        successSaga: ({ response }: { response?: CallResponseGetQuizById }) => {
          // refresh the quiz only if not completed otherwise the user will be redirected to Training page
          if (response?.userStatus && response.userStatus !== UserQuizStatusEnum.COMPLETED) {
            executePostQuizStart({
              quizId,
            });
            return;
          }
          navigate(Routes.TrainingHardSkills);
        },
      });
    }
  }, [
    executePostQuizStart,
    responseGetContentDetails?.id,
    quizId,
    executeGetContentDetails,
    navigate,
  ]);

  if (loadingPostQuizStart || loadingGetContentDetails) {
    return (
      <Box position='absolute' height='100vh' width='100vw' top='0' left='0' right='0' bottom='0'>
        <LoadingPage />
      </Box>
    );
  }

  return <Wizard stepsConfig={wizardSteps} />;
};
